"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveNewTaxVatData = exports.loadTaxVatNumbers = exports.TaxNumbersActions = void 0;
exports.setApiError = setApiError;
exports.setLoader = setLoader;
exports.setTaxVatNumbersChangeEvents = setTaxVatNumbersChangeEvents;
var _taxVatinPageTypes = require("../../pages/TaxVatDetailsPage/taxVatinPageTypes");
var _taxNumberApi = require("../../../api-factory/taxNumberApi");
var TaxNumbersActions = exports.TaxNumbersActions = /*#__PURE__*/function (TaxNumbersActions) {
  TaxNumbersActions["IS_LOADING"] = "IS_LOADING";
  TaxNumbersActions["LOAD_TAX_VAT_NUMBERS"] = "LOAD_TAX_VAT_NUMBERS";
  TaxNumbersActions["SAVE_TAX_DATA"] = "SAVE_TAX_DATA";
  TaxNumbersActions["SET_API_ERROR"] = "SET_API_ERROR";
  TaxNumbersActions["SET_TAX_VAT_NUMBERS_CHANGE_EVENTS"] = "SET_TAX_VAT_NUMBERS_CHANGE_EVENTS";
  return TaxNumbersActions;
}(TaxNumbersActions || {});
var loadTaxVatNumbers = exports.loadTaxVatNumbers = function loadTaxVatNumbers(dispatch, contractAccountId) {
  setLoader(dispatch);
  (0, _taxNumberApi.getTaxVatNumbers)(contractAccountId).then(function (response) {
    dispatch({
      type: TaxNumbersActions.LOAD_TAX_VAT_NUMBERS,
      taxNumbers: response.data
    });
  }).catch(function (error) {
    setApiError(dispatch, true, error);
  });
};
var saveNewTaxVatData = exports.saveNewTaxVatData = function saveNewTaxVatData(dispatch, contractAccountId, data) {
  setLoader(dispatch);
  return (0, _taxNumberApi.saveTaxVatNumber)(contractAccountId, data).then(function (response) {
    dispatch({
      type: TaxNumbersActions.SAVE_TAX_DATA,
      taxNumbers: response.data
    });
  }).catch(function (error) {
    setApiError(dispatch, true, error);
  });
};
var getEvent = function getEvent(oldValue, newValue, defaultValue) {
  if (oldValue === defaultValue && newValue !== defaultValue) {
    return _taxVatinPageTypes.TaxNumberChangeEvents.SAVE;
  }
  if (oldValue !== newValue) {
    return _taxVatinPageTypes.TaxNumberChangeEvents.UPDATE;
  }
  return _taxVatinPageTypes.TaxNumberChangeEvents.NONE;
};
function setTaxVatNumbersChangeEvents(dispatch, oldValues, newValues) {
  var taxinEvent = (newValues === null || newValues === void 0 ? void 0 : newValues.taxin) ? getEvent(oldValues.taxin, newValues.taxin, '') : _taxVatinPageTypes.TaxNumberChangeEvents.NONE;
  var vatinEvent = (newValues === null || newValues === void 0 ? void 0 : newValues.vatin) ? getEvent(oldValues.vatin, newValues.vatin, 'DE') : _taxVatinPageTypes.TaxNumberChangeEvents.NONE;
  dispatch({
    type: TaxNumbersActions.SET_TAX_VAT_NUMBERS_CHANGE_EVENTS,
    taxNumbersChangeEvent: {
      taxin: taxinEvent,
      vatin: vatinEvent
    }
  });
}
function setLoader(dispatch) {
  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  dispatch({
    type: TaxNumbersActions.IS_LOADING,
    isLoading: isLoading
  });
}
function setApiError(dispatch) {
  var hasApiError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    message: ''
  };
  dispatch({
    type: TaxNumbersActions.SET_API_ERROR,
    hasApiError: hasApiError,
    apiErrorMessage: error.message
  });
}